<div class="container" *ngIf="auditClaimsCEs$ | async as claimsCEs">
  <ng-container *ngIf="auditClaimsCEsContact$ | async as claimsCEsContact">
    <div class="container__form" [formGroup]="form">
      <kendo-grid
        #claimsGrid
        class="claims-grid rb-grid-row-detail"
        [kendoGridBinding]="claims"
        [loading]="claimsCEs.pending || claimsCEsContact.pending"
        [resizable]="true"
      >
        <ng-template kendoGridToolbarTemplate>
          <div class="toolbar-container">
            <div class="toolbar-container__left">
              Select CE(s) to contact for each claim
            </div>
            <div class="toolbar-container__right"></div>
          </div>
        </ng-template>

        <ng-container *ngFor="let col of claimsColumns.values()">
          <ng-container [ngSwitch]="col.type">
            <!-- String Column -->
            <ng-container *ngSwitchCase="'string'">
              <kendo-grid-column
                [field]="col.field"
                [title]="col.title"
                headerClass="rb-header-hide-filter"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    class="grid-cell-truncated"
                    kendoTooltip
                    appTooltipOnEllipsis
                    [tooltipText]="dataItem[col.field]"
                    filter=".rb-display-kendo-tooltip"
                  >
                    {{ dataItem[col.field] }}
                  </span>
                </ng-template>
              </kendo-grid-column>
            </ng-container>

            <!-- Numeric Column -->
            <ng-container *ngSwitchCase="'numeric'">
              <kendo-grid-column [field]="col.field" [title]="col.title">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    class="grid-cell-truncated"
                    kendoTooltip
                    appTooltipOnEllipsis
                    [tooltipText]="dataItem[col.field]"
                    filter=".rb-display-kendo-tooltip"
                  >
                    {{ dataItem[col.field] }}
                  </span>
                </ng-template>
              </kendo-grid-column>
            </ng-container>

            <!-- Percentage Column -->
            <ng-container *ngSwitchCase="'percentage'">
              <kendo-grid-column [field]="col.field" [title]="col.title">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    class="grid-cell-truncated"
                    kendoTooltip
                    appTooltipOnEllipsis
                    [tooltipText]="dataItem[col.field] | percent"
                    filter=".rb-display-kendo-tooltip"
                  >
                    {{ dataItem[col.field] | percent }}
                  </span>
                </ng-template>
              </kendo-grid-column>
            </ng-container>

            <!-- Date Column -->
            <ng-container *ngSwitchCase="'date'">
              <kendo-grid-column [field]="col.field" [title]="col.title">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    class="grid-cell-truncated"
                    kendoTooltip
                    appTooltipOnEllipsis
                    [tooltipText]="dataItem[col.field] | date: 'M/d/yyyy'"
                    filter=".rb-display-kendo-tooltip"
                  >
                    {{ dataItem[col.field] | date: 'M/d/yyyy' }}
                  </span>
                </ng-template>
              </kendo-grid-column>
            </ng-container>

            <!-- Dropdown Column -->
            <ng-container *ngSwitchCase="'dropdown'">
              <kendo-grid-column
                [field]="col.field"
                [title]="col.title"
                headerClass="rb-header-hide-filter"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  <ng-container [ngSwitch]="col.field">
                    <ng-container
                      *ngSwitchCase="
                        ['StatusCategoryId', 'StatusCategory340B'].includes(
                          col.field
                        )
                          ? col.field
                          : ''
                      "
                    >
                      <span
                        class="grid-cell-truncated"
                        kendoTooltip
                        appTooltipOnEllipsis
                        [tooltipText]="
                          dataItem[col.field] | claim340bStatusYesNo
                        "
                        filter=".rb-display-kendo-tooltip"
                      >
                        {{ dataItem[col.field] | claim340bStatusYesNo }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'isDisputed'">
                      <span
                        class="grid-cell-truncated"
                        kendoTooltip
                        appTooltipOnEllipsis
                        [tooltipText]="dataItem[col.field] | auditDisputeStatus"
                        filter=".rb-display-kendo-tooltip"
                      >
                        {{ dataItem[col.field] | auditDisputeStatus }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'isApproved'">
                      <span
                        class="grid-cell-truncated"
                        kendoTooltip
                        appTooltipOnEllipsis
                        [tooltipText]="
                          dataItem[col.field] | auditResolutionStatus
                        "
                        filter=".rb-display-kendo-tooltip"
                      >
                        {{ dataItem[col.field] | auditResolutionStatus }}
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <span
                        class="grid-cell-truncated"
                        kendoTooltip
                        appTooltipOnEllipsis
                        [tooltipText]="dataItem[col.field]"
                        filter=".rb-display-kendo-tooltip"
                      >
                        {{ dataItem[col.field] }}
                      </span>
                    </ng-container>
                  </ng-container>
                </ng-template>
              </kendo-grid-column>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-template kendoGridDetailTemplate let-claim="dataItem">
          <kendo-grid
            class="ce-grid"
            [kendoGridBinding]="getClaimCEs(claim, claimsCEs)"
            [resizable]="true"
            [selectable]="{ mode: 'multiple', checkboxOnly: true }"
            [rowSelected]="isCERowSelectedFn(claim)"
            (selectionChange)="selectCE(claim, $event)"
          >
            <kendo-grid-column
              field="id340b"
              title="CE 340B ID"
            ></kendo-grid-column>

            <kendo-grid-column field="contactName" title="Contact Name">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.contactName">
                  {{ dataItem.contactName }}
                </span>
                <span *ngIf="!dataItem.contactName">
                  <kendo-formfield
                    *ngIf="isCERowSelected(claim, dataItem); else nameTemplate"
                  >
                    <ng-template #nameTooltipTemplate>
                      <span>{{
                        getControlErrorMsg('name_' + dataItem.id340b)
                      }}</span>
                    </ng-template>
                    <kendo-textbox
                      class="form-field"
                      [class.name-error-tooltip]="
                        form.get('name_' + dataItem.id340b)?.invalid
                      "
                      [formControlName]="'name_' + dataItem.id340b"
                      [value]="form.value['name_' + dataItem.id340b]"
                      [maxlength]="100"
                      kendoTooltip
                      [tooltipTemplate]="nameTooltipTemplate"
                      filter=".name-error-tooltip"
                    ></kendo-textbox>
                  </kendo-formfield>
                  <ng-template #nameTemplate>
                    {{ form.value['name_' + dataItem.id340b] }}
                  </ng-template>
                </span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="contactEmail" title="Contact Email">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.contactEmail">
                  {{ dataItem.contactEmail }}
                </span>
                <div *ngIf="!dataItem.contactEmail">
                  <kendo-formfield
                    *ngIf="isCERowSelected(claim, dataItem); else emailTemplate"
                  >
                    <ng-template #emailTooltipTemplate>
                      <span>{{
                        getControlErrorMsg('email_' + dataItem.id340b)
                      }}</span>
                    </ng-template>
                    <kendo-textbox
                      class="form-field"
                      [class.email-error-tooltip]="
                        form.get('email_' + dataItem.id340b)?.invalid
                      "
                      [formControlName]="'email_' + dataItem.id340b"
                      [value]="form.value['email_' + dataItem.id340b]"
                      [maxlength]="100"
                      kendoTooltip
                      [tooltipTemplate]="emailTooltipTemplate"
                      filter=".email-error-tooltip"
                    >
                      <ng-template kendoTextBoxSuffixTemplate>
                        <kendo-loader
                          *ngIf="
                            emailValidationLoading$.get(dataItem.id340b)
                              | async;
                            else emailValidIcon
                          "
                          style="margin-right: 10px"
                          type="infinite-spinner"
                          themeColor="primary"
                          size="small"
                        >
                        </kendo-loader>
                        <ng-template #emailValidIcon
                          ><span
                            *ngIf="form.get('email_' + dataItem.id340b)?.valid"
                            class="k-icon k-font-icon k-i-checkmark"
                          ></span
                        ></ng-template>
                      </ng-template>
                    </kendo-textbox>
                  </kendo-formfield>
                  <ng-template #emailTemplate>
                    {{ form.value['email_' + dataItem.id340b] }}
                  </ng-template>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-checkbox-column
              [width]="60"
              headerClass="k-text-center"
              class="k-text-center"
              [columnMenu]="false"
              [showSelectAll]="false"
            >
              <ng-template
                kendoGridCellTemplate
                let-idx="rowIndex"
                let-dataItem="dataItem"
              >
                <input
                  kendoCheckBox
                  type="checkbox"
                  [kendoGridSelectionCheckbox]="idx"
                  [disabled]="claimsCEs.pending || claimsCEsContact.pending"
                />
              </ng-template>
            </kendo-grid-checkbox-column>

            <ng-template kendoGridNoRecordsTemplate>
              No CEs associated with this claim
            </ng-template>
          </kendo-grid>
        </ng-template>
      </kendo-grid>
    </div>

    <kendo-dialog-actions class="container__toolbar">
      <div class="container__buttons">
        <button kendoButton class="container__button" (click)="close()">
          Cancel
        </button>
        <button
          kendoButton
          [primary]="true"
          class="container__button"
          (click)="submit()"
          [disabled]="
            !selectedCEs.length ||
            !form.valid ||
            claimsCEs.pending ||
            claimsCEsContact.pending
          "
        >
          Submit
        </button>
      </div>
    </kendo-dialog-actions>
  </ng-container>
</div>
